import { MetaDefinition } from '@angular/platform-browser';
import { AppConfig } from '@qaroni-core/config/app/app.config';
import { BucketS3Env } from '@qaroni-core/config/bucket-s3/bucket-s3.config';

export const METATAGSARRAY: MetaDefinition[] = [
  {
    name: 'description',
    content: `${AppConfig.description}`,
  },
  {
    name: 'keywords',
    content: `${AppConfig.keywords}`,
  },
  {
    name: 'msapplication-square70x70logo',
    content: `${BucketS3Env.baseUrl}/favicon/smalltile.png`,
  },
  {
    name: 'msapplication-square150x150logo',
    content: `${BucketS3Env.baseUrl}/favicon/mediumtile.png`,
  },
  {
    name: 'msapplication-wide310x150logo',
    content: `${BucketS3Env.baseUrl}/favicon/widetile.png`,
  },
  {
    name: 'msapplication-square310x310logo',
    content: `${BucketS3Env.baseUrl}/favicon/largetile.png`,
  },

  // Schema.org markup for Google
  { itemprop: 'name', content: `${AppConfig.name}` },
  {
    itemprop: 'description',
    content: `${AppConfig.description}`,
  },
  {
    itemprop: 'image',
    content: `${BucketS3Env.baseUrl}/images/post-sign-up.png`,
  },
];
